import type { WellnessTrain } from './wellness-train.type.ts';
export interface WellnessTrainExtension extends WellnessTrain {}
export class WellnessTrainExtension {
  get sortedComponentDefinitions() {
    return this.componentDefinitions.slice().sort((a, b) => a.order - b.order);
  }

  get scoreDefinition() {
    return this.componentDefinitions.find((definition) => 'score' === definition.type);
  }

  get summaryDefinition() {
    return this.componentDefinitions.find((definition) => 'dash_summary' === definition.type);
  }

  get accountPromptDefinition() {
    return this.componentDefinitions.find((definition) => 'add_account' === definition.type);
  }

  get recommendationDefinitions() {
    return this.componentDefinitions
      .filter((definition) =>
        [
          'to_coaching',
          'to_pslf_tool',
          'to_idr_tool',
          'to_nslds_upload',
          'to_refinancing_tool',
          'to_strategy_finder',
          'to_pslf_form_submission',
          'transitional_strategy_finder_results',
          'transitional_pslf_form_submission',
          'transitional_pslf_tool_results',
          'transitional_idr_results',
        ].includes(definition.type)
      )
      .sort((a, b) => a.order - b.order);
  }
}

const Registration = {
  kind: 'object',
  name: 'wellness-train',
  features: WellnessTrainExtension,
};
export default Registration;
